// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__2Wuec","light":"Label_light__2bMnd"};